import React, { useState, useEffect, useCallback, useContext } from 'react';
import './List.css';
import '../App.css';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import LoadingComponent from '../components/LoadingComponent';
import {
  createStyles,
  Grid,
  makeStyles,
  Snackbar,
  Theme,
  Button
} from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { ButtonField } from '../components/parts/cloudStorage/ButtonField';
import { FolderField } from '../components/fileListPage/FolderField';
import { SearchField } from '../components/fileListPage/SearchField';
import {
  getFileFolder,
  getFileList,
  getFilesZip,
  moveFolderFile,
  deleteFolder,
  deleteFile,
  getFileDownload
} from '../apicalls/cloudFile';
import { getFileTypes } from '../apicalls/cloud/fileType';
import { useForm, UseFormReturn } from 'react-hook-form';
import {
  TCloudFileListForm,
  TFoldrtList,
  TFolderFile,
  TFile,
  TEcontractStatus
} from '../types/cloudStorage/CloudFileList';
import { TInpteSelectItem, TSelectItem } from '../types/common';
import { getVendorList } from '../apicalls/getVendorDetails';
import { FolderModal } from '../components/fileListPage/FolderModal';
import { DeleteModal } from '../components/fileListPage/DeleteModal';
import { useRecoilState } from 'recoil';
import {
  checkResData,
  createParams,
  getConstructionsSelectBoxData
} from '../utils/common';
import { useHistory } from 'react-router-dom';
import {
  isEContractServiceEnabledState,
  openErrorFlg,
  openSuccessFlg,
  progressFlgState,
  resMessage
} from '../GlobalState';
import zIndex from '@material-ui/core/styles/zIndex';
import { SnackbarProvider, useSnackbar } from 'notistack';

import { AuthInfoContext } from '../AuthContextProvider';
import { ROLE } from '../const/Const';

export const FileListPage: React.FC = () => {
  const history: any = useHistory();
  // 案件ID
  const constructId = history.location?.state?.state?.id ?? 0;

  const constructIdDef =
    constructId === 0
      ? { value: 0, label: '--' }
      : {
          value: constructId,
          label: history.location?.state?.state?.name ?? '--'
        };

  // 初期データ
  const defaultValues: TCloudFileListForm = {
    construct_id: constructIdDef,
    folder_id: undefined,
    date_from: '',
    date_end: '',
    amount_from: '',
    amount_end: '',
    send_to: { value: 0, label: '--' },
    receive_from: { value: 0, label: '--' },
    keyword: '',
    file_type_id: { value: 0, label: '--' }
  };

  const classes = useStyles();

  const { enqueueSnackbar } = useSnackbar();

  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  // ログイン状態
  const [isLogin, setIsLogin] = useState<boolean>(false);
  // エラーメッセージ
  const [errorMessage, setErrorMessage] = useRecoilState(resMessage);
  // メッセージ表示フラグ
  const [openSuccess, setOpenSuccess] = useRecoilState(openSuccessFlg);
  // エラーメッセージ表示フラグ
  const [open, setOpen] = useRecoilState(openErrorFlg);
  const [isEContractServiceEnabled, setIsEContractServiceEnabled] =
    useRecoilState<any>(isEContractServiceEnabledState);
  // ローディング表示フラグ
  const [loading, setLoading] = useState(false);
  // 案件選択値
  const [selectItem, setSelectItem] = useState<TSelectItem[]>([]);
  // 業者リスト
  const [vendorsList, setVendorsList] = useState<TSelectItem[]>([]);
  // 種別リスト
  const [fileTypes, setFileTypes] = useState<TSelectItem[]>([]);
  // モーダルオープン
  const [modalOpen, setModalOpen] = useState(false);
  // フォルダーリスト(ファイルデータ含む)
  const [folderList, setFolderList] = useState<TFolderFile[]>([]);

  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);

  const [folderSelectList, setFolderSelectList] = useState<TInpteSelectItem[]>(
    []
  );

  // 選択したファイルID
  const [selectedFiles, setSelectedFiles] = useState<TFile[]>([]);
  // 削除モーダルオープン
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  // 検索モード
  const [searchMode, setSearchMode] = useState<string>('');
  // ボタンエリア表示フラグ
  const [buttonAreaFlg, setButtonAreaFlg] = useState<boolean>(false);
  // hook-formの初期設定
  const methods: UseFormReturn<TCloudFileListForm, any> = useForm({
    defaultValues
  });
  const {
    setValue,
    getValues,
    handleSubmit,
    reset,
    watch,
    formState: { errors }
  } = methods;

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  /**
   * 選択ファイルを追加
   * @param file
   */
  const addSelectedFiles = (file: TFile) => {
    if (!selectedFiles.includes(file)) {
      setSelectedFiles([...selectedFiles, file]);
    }
  };

  /**
   * 選択ファイルを追加(全件)
   * @param file
   */
  const addAllSelectedFiles = (files: TFile[]) => {
    let tempArr: TFile[] = [];
    tempArr = tempArr.concat(selectedFiles);
    files.map(file => {
      if (!tempArr.includes(file)) {
        tempArr.push(file);
      }
    });
    setSelectedFiles(tempArr);
  };

  /**
   * 選択ファイルを削除
   * @param file
   */
  const removeSelectedFiles = (file: TFile) => {
    if (selectedFiles.includes(file)) {
      const newSelectedFileIds = selectedFiles.filter(f => f.id !== file.id);
      setSelectedFiles(newSelectedFileIds);
    }
  };

  /**
   * 選択ファイルを削除(全件)
   * @param file
   */
  const removeAllSelectedFiles = (files: TFile[]) => {
    let tempArr: TFile[] = selectedFiles;
    files.map(file => {
      if (tempArr.includes(file)) {
        tempArr = tempArr.filter(f => f.id !== file.id);
      }
    });
    setSelectedFiles(tempArr);
  };

  /**
   * モーダルのファイル選択の一覧表示
   */
  const getSelectedLists = () => {
    return (
      <>
        <Grid item>
          <div className={classes.bodyListArea} style={{ textAlign: 'center' }}>
            {selectedFiles.map((file: TFile) => {
              return <p>{file.name}</p>;
            })}
          </div>
        </Grid>
      </>
    );
  };

  /**
   * 検索処理
   * @param mode 検索ボタンか案件選択か
   */
  const getFolderFileList = async (mode?: string) => {
    const formParams = {
      construct_id: getValues('construct_id')?.value,
      folder_id: getValues('folder_id'),
      date_from: getValues('date_from'),
      date_end: getValues('date_end'),
      amount_from: getValues('amount_from'),
      amount_end: getValues('amount_end'),
      send_to: getValues('send_to')?.value,
      receive_from: getValues('receive_from')?.value,
      keyword: getValues('keyword'),
      file_type_id: getValues('file_type_id')?.value
    };

    if (!formParams.construct_id) {
      setFolderList([]);
      return;
    }

    if (mode != undefined) {
      setSearchMode(mode);
    }

    const param: string = await createParams(formParams);

    const folderFile: TFolderFile[] = [];
    const selectList: TInpteSelectItem[] = [];
    await getFileFolder(param)
      .then(async resData => {
        await checkResData(resData, enqueueSnackbar).then(async (data: any) => {
          const folderList: TFoldrtList[] = data.data;
          for (let i = 0; folderList.length > i; i++) {
            const folder: TFoldrtList = folderList[i];
            await getFileList(folder.id, param).then(async (resData: any) => {
              await checkResData(resData, enqueueSnackbar).then(
                async (data: any) => {
                  const folderData: TFolderFile = {
                    id: folder.id,
                    name: folder.name,
                    construct_id: folder.construct_id,
                    construct_name: folder.construct_name,
                    file_count: folder.file_count,
                    files: data.data,
                    e_contract_service_id: isEContractServiceEnabled
                  };

                  let modeName = '';

                  if (mode != undefined) {
                    modeName = mode;
                  } else {
                    modeName = searchMode;
                  }

                  // 案件選択の場合
                  switch (modeName) {
                    case 'onSearch':
                      if (folderData.files.length > 0) {
                        folderFile.push(folderData);
                        selectList.push({
                          id: folderData.id,
                          name: folderData.name
                        });
                      }
                      break;
                    default:
                      folderFile.push(folderData);
                      selectList.push({
                        id: folderData.id,
                        name: folderData.name
                      });
                  }
                }
              );
            });
          }
        });
      })
      .then(() => {
        setFolderList(folderFile);
        setFolderSelectList(selectList);
      });

    // selectedFileIdsをリセット
    setSelectedFiles([]);
  };

  /**
   * zipダウンロード
   */
  const downloadFileZip = async () => {
    setProgressFlg(true);

    if (selectedFiles.length <= 0) {
      return;
    }

    if (selectedFiles.length == 1) {
      await getFileDownload(String(selectedFiles[0].id), true).then(
        (resData: any) => {
          checkResData(resData, enqueueSnackbar).then((data: any) => {
            // 書類ダウンロード
            let bin = atob(data.data.replace(/^.*,/, ''));

            let buffer = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) {
              buffer[i] = bin.charCodeAt(i);
            }

            let fileData = new File([buffer.buffer], data.data, {
              type: data.file_format
            });

            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(fileData);
            const fileName = selectedFiles[0].name;
            downloadLink.download = fileName;
            downloadLink.click();
          });
        }
      );
    } else {
      const params: string = selectedFiles
        .map(file => {
          return file.id;
        })
        .join(',');

      await getFilesZip(params).then((resData: any) => {
        checkResData(resData, enqueueSnackbar).then((data: any) => {
          // 書類ダウンロード
          let bin = atob(data.data.replace(/^.*,/, ''));

          let buffer = new Uint8Array(bin.length);
          for (let i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i);
          }

          let fileData = new File([buffer.buffer], data.data, {
            type: data.file_format
          });

          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(fileData);
          const fileName = 'document-list.zip';
          downloadLink.download = fileName;
          downloadLink.click();
        });
      });
    }

    // selectedFileIdsをリセット
    setSelectedFiles([]);
    setProgressFlg(false);
  };

  /**
   * フォルダー移動
   */
  const moveFolder = async (folderId: number) => {
    for (let i = 0; selectedFiles.length > i; i++) {
      await moveFolderFile(selectedFiles[i].id, folderId).then(
        (resData: any) => {
          checkResData(resData, enqueueSnackbar);
        }
      );
    }

    getFolderFileList();
  };

  /**
   * フォルダ削除
   * @param folderId
   */
  const onDeleteFolder = async (folderId: number) => {
    await deleteFolder(folderId).then(resData => {
      checkResData(resData, enqueueSnackbar);
    });

    await getFolderFileList();
  };

  /**
   * 選択ファイル削除
   */
  const onDeleteFile = () => {
    selectedFiles.forEach(file => {
      deleteFile(file.id).then(resData => {
        checkResData(resData, enqueueSnackbar).then(() => {
          getFolderFileList();
        });
      });
    });
    setDeleteModalOpen(false);
  };

  useEffect(() => {
    setLoading(true);
    setErrorMessage('');
    setOpenSuccess(false);
    setOpen(false);

    if (constructId != 0) {
      getFolderFileList();
    }

    if (constructId && constructId != 0) {
      setButtonAreaFlg(true);
    } else {
      setButtonAreaFlg(false);
    }

    // 工事セレクトボックスを取得
    getConstructionsSelectBoxData(setSelectItem, enqueueSnackbar, {
      value: 0,
      label: '--'
    });

    //資料種別
    getFileTypes().then((resData: any) => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        const list: TSelectItem[] = [];
        list.push({ value: 0, label: '--' });
        // 案件名プルダウン選択値設定
        data.data.map((data: any) => {
          list.push({ value: data.id, label: data.name });
        });
        setFileTypes(list);
      });
    });

    //業者一覧に変更する
    getVendorList().then((resData: any) => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        const list: TSelectItem[] = [];
        list.push({ value: 0, label: '--' });
        // 案件名プルダウン選択値設定
        data.data.map((data: any) => {
          list.push({ value: data.id, label: data.name });
        });
        setVendorsList(list);
      });
    });

    setLoading(false);
  }, [constructId]);

  // ----------描画部分----------------------------------
  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      {/* ヘッダー */}
      <AppBarComponent patternName='files' />
      {/* ローディング */}
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            // overflow: "hidden",
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          {/* ページタイトル */}
          <div style={{ backgroundColor: '#FFFFFF' }}>
            <div
              style={{
                fontWeight: 'bold',
                padding: 15,
                fontSize: 24
              }}
            >
              資料一覧
            </div>
          </div>

          {/* 検索コンポーネント */}
          <SearchField
            methods={methods}
            selectItem={selectItem}
            vendorsList={vendorsList}
            fileTypes={fileTypes}
            handleSubmit={handleSubmit}
            getFolderFileList={getFolderFileList}
            errors={errors}
            getValues={getValues}
            reset={reset}
            constructIdDef={constructIdDef}
            setButtonAreaFlg={setButtonAreaFlg}
            watch={watch}
          />

          {/* ボタンコンポーネント */}
          {buttonAreaFlg && authInfo?.role !== ROLE['OUTSIDE_PARTNER'] && (
            <div style={{ position: 'sticky', top: 60, zIndex: 10 }}>
              <ButtonField
                setModalOpen={setModalOpen}
                setDeleteModalOpen={setDeleteModalOpen}
                downloadZip={downloadFileZip}
                moveFolder={moveFolder}
                folderSelectList={folderSelectList}
                getSelectedLists={getSelectedLists}
                name='資料'
                selectFiles={selectedFiles}
              />
            </div>
          )}

          <div style={{ zIndex: -10 }}>
            {/* フォルダコンポーネント */}
            {folderList.map((folder: TFolderFile) => (
              <FolderField
                vendorsList={vendorsList}
                fileTypes={fileTypes}
                key={folder.id}
                folder={folder}
                getValues={getValues}
                getFolderFileList={getFolderFileList}
                addSelectedFiles={addSelectedFiles}
                removeSelectedFiles={removeSelectedFiles}
                addAllSelectedFiles={addAllSelectedFiles}
                removeAllSelectedFiles={removeAllSelectedFiles}
                selectedFiles={selectedFiles}
                onDeleteFolder={onDeleteFolder}
              />
            ))}
          </div>

          {/* フォルダ追加モーダル */}
          <FolderModal
            selectItem={selectItem}
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            getFolderFileList={getFolderFileList}
            constructIdDef={getValues('construct_id')}
          />

          {/* 資料削除モーダル */}
          <DeleteModal
            modalOpen={deleteModalOpen}
            setModalOpen={setDeleteModalOpen}
            deleteFiles={selectedFiles}
            onDeleteFile={onDeleteFile}
          />
        </div>
      )}
      {/* フッター */}
      <FooterComponent />
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    bodyListArea: {
      maxHeight: '300px',
      width: '100%',
      padding: theme.spacing(5)
    }
  })
);
